import { Box, styled, Theme } from '@mui/material';

export const ProfileMainWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    maxWidth: '440px', // TODO NEED TO RESEARCH
    width: '100%',
    height: '100%',

    [theme.breakpoints.down('tablet')]: {
      maxWidth: '100%',
    },
  };
}) as typeof Box;

export const FormWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column',

    '> form': {
      width: '100%',
    },
  };
}) as typeof Box;
